var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox-tool",class:{ 'active-tool': _vm.isToolActive },style:('background-image:url(' + _vm.imagePath(_vm.image) + ');'),attrs:{"draggable":"false"},on:{"click":_vm.setCanvasTool}})}
var staticRenderFns = []

export { render, staticRenderFns }